import request from "../utils/Request";

let globalConf;

export function config() {
    return new Promise((resolve, reject)=>{
        if(globalConf){
            return resolve(globalConf);
        }

        
    });
}

export function oAuth() {
    // cz.dichangshangmao.com%252Findex.html%2523%252Fpublic%252Foauth/public/oauth
    request.post("/oauth").then(res=>{
        if(res.status == 1){
            location.href = 'http://meijia.dichangshangmao.com/code.php?ask_type=sdfsdfsdfdsd';

            // location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${res.data.appid}&redirect_uri=${res.data.url}/public/oauth&response_type=code&scope=snsapi_userinfo&state=${res.data.state}#wechat_redirect`;
            // location.href = 'http://meijia.dichangshangmao.com/code.php?ask_type=ksdfhjsdkfjk';
        }
    });
}
